export const arrowDown = 40;
export const arrowUp = 38;
export const arrowLeft = 37;
export const arrowRight = 39;
export const enter = 13;
export const escape = 27;
